<template>
  <div>
    <div class="form-card">
      <h3 class="form-card-title">
        <span class="title-text">{{ $t('labels.ga') }}</span>
      </h3>
      <div class="relative-position" v-if="Getter_User_Info.gaStatus === 1">
        <div class="form-card-body">
          <div class="color-333">{{ $t('labels.acc.ga.setupSuccess') }}</div>
        </div>
      </div>
      <div class="relative-position" v-if="Getter_User_Info.gaStatus === 0">
        <div class="form-card-body border-bottom-1px mb-15">
          <p class="color-333">{{ $t('labels.acc.ga.desc2') }}</p>
          <div class="step-bar">
            <div class="step-bar-item">
              <div class="step-bar-icon">
                <svg class="iconfont-symbol" aria-hidden="true">
                  <use xlink:href="#icon-icon-test22" />
                </svg>
              </div>
              <p class="step-introduce-text">1. {{ $t('labels.acc.ga.step1') }}</p>
            </div>
            <div class="step-bar-item">
              <div class="step-bar-icon">
                <svg class="iconfont-symbol" aria-hidden="true">
                  <use xlink:href="#icon-icon-test23" />
                </svg>
              </div>
              <p class="step-introduce-text">2. {{ $t('labels.acc.ga.step2') }}</p>
            </div>
            <!-- <div class="step-bar-item">
              <div class="step-bar-icon">
                <svg class="iconfont-symbol" aria-hidden="true">
                  <use xlink:href="#icon-icon-test24"></use>
                </svg>
              </div>
              <p class="step-introduce-text">3、开启谷歌验证码</p>
            </div>-->
          </div>
        </div>

        <div class="left-patch"></div>
        <div class="right-patch"></div>
        <div class="form-card-foot border-top-1px">
          <!-- <div class="step step1" v-show="currentStep === 'step1'">
            <div class="text-center pt-5">
              <div class="inline-block">
                <span class="serial-num mr-10">1</span>
                <span class="step-text font-16">可以选择下载谷歌验证器APP或者关注小程序“二次验证码</span>
              </div>
            </div>
            <div class="btn-wrap">
              <q-btn
                class="no-shadow step-btn go-download-btn"
                label="下载谷歌验证器APP"
                @click="step1NextBtnClick(true)"/>
              <q-btn
                class="no-shadow step-btn go-download-btn"
                label="关注小程序“二次验证码”"
                @click="step1NextBtnClick(false)"/>
            </div>
          </div>-->
          <div class="step step2">
            <div class="step-app" v-show="isApp">
              <div class="step2-container">
                <div class="left-text">
                  <div class="inline-block">
                    <span class="serial-num mr-10">1</span>
                    <span class="step-text font-16">{{ $t('labels.acc.ga.step1') }}</span>
                  </div>
                </div>
                <div class="right-download">
                  <div class="btns-group">
                    <a
                      href="https://itunes.apple.com/cn/app/google-authenticator/id388497605?mt=8"
                      target="_blank"
                      class="download-btn ios-app-store"
                    >APP STORE</a>
                    <a
                      href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"
                      target="_blank"
                      class="download-btn google-play"
                    >GOOGLE PLAY</a>
                    <!-- <q-btn
                      class="no-shadow step-btn prev-step"
                      label="上一步"
                      @click="currentStep = 'step1'"/>
                    <q-btn
                      class="no-shadow step-btn next-step"
                      label="下一步"
                    @click="currentStep = 'step3'"/>-->
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="step-smallApp" v-show="!isApp">
              <div class="text-center mb-25">
                <div class="inline-block">
                  <span class="serial-num mr-10">1</span>
                  <span class="step-text">关注小程序“二次验证码”</span>
                </div>
              </div>
              <div class="google-verification-use-guide">
                <div class="use-guid-step">
                  <p class="color-333 text-center">一、微信扫描如下二维码，扫描后示例如右图</p>
                  <div class="text-center mt-30 pt-15">
                    <div class="qr-code-wrap">
                      <img src="../../../assets/images/temp_qr.png" alt="">
                    </div>
                  </div>
                </div>
                <div class="use-guid-step">
                  <p class="color-333 text-center">二、点击“开始使用”</p>
                  <div class="text-center">
                    <img src="../../../assets/images/smallApp_temp.png" alt="">
                  </div>
                </div>
              </div>

              <div class="btn-wrap">
                <q-btn
                  class="no-shadow step-btn prev-step"
                  label="上一步"
                  @click="currentStep = 'step1'"/>
                <q-btn
                  class="no-shadow step-btn next-step"
                  label="下一步"
                  @click="currentStep = 'step3'"/>
              </div>
            </div>-->
          </div>
          <div class="step step3">
            <div class="mb-25">
              <div class="serial-num mr-10">2</div>
              <div class="step-text">{{ $t('labels.acc.ga.desc3') }}</div>
            </div>
            <div class="qr-code-wrap mb-30">
              <div id="google_code_qrcode"></div>
              <!--<img src="../../../assets/images/temp_qr.png" alt="">-->
            </div>
            <p class="color-333">{{ $t('labels.acc.ga.desc4') }}</p>
            <div class="d-flex align-items-center">
              <!--<input type="text" class="form-control secret-key-input">-->
              <!-- <div
                class="quasar-qfield glay-bg secret-key-input"
                data-error="form.identityNo.$error"
                data-error-label="getErrorLabel(form.identityNo, 'identityNo')"
              >
                <v-text-field
                  id="view_secret_input"
                  v-model="form.secret"
                  :readonly="true"
                  :float-label="$t('labels.acc.ga.secret')"
                />
              </div>-->

              <TextFieldComponent
                id="view_secret_input"
                class="flex-fill mr-3 readonly"
                :outlined="true"
                :label="$t('labels.acc.ga.secret')"
                :value="form.secret"
                :readonly="true"
              ></TextFieldComponent>

              <div
                class="copy-btn"
                v-clipboard:copy="form.secret"
                v-clipboard:success="copySuccess"
                v-clipboard:error="copyError"
              >{{ $t('actions.copy') }}</div>
            </div>
            <p class="mt-3color-999">{{ $t('labels.acc.ga.desc5') }}</p>
            <!-- <div class="btn-wrap text-left">
              <q-btn
                class="no-shadow step-btn prev-step"
                label="上一步"
                @click="currentStep = 'step2'"/>
              <q-btn
                class="no-shadow step-btn next-step"
                label="下一步"
                @click="step3NextBtnClick"/>
            </div>-->
          </div>
          <div class="step step4">
            <!-- <div class="mb-25">
              <div class="serial-num mr-10">3</div>
              <div class="step-text">将生成的动态验证码填写到如下输入框中</div>
            </div>-->
            <div class="form">
              <!-- <div class="form-group">
                <div
                  class="quasar-qfield glay-bg secret-key-input"
                  error-label=" ">
                  <v-text-field
                    v-model="form.secret"
                    :readonly="true"
                    float-label="秘钥" />
                </div>
              </div>-->
              <div class="form-group mb-3">
                <TextFieldComponent
                  class="readonly"
                  :outlined="true"
                  :label="$t('labels.acc.ga.device')"
                  :value="deviceName"
                  :readonly="true"
                ></TextFieldComponent>
              </div>
              <!-- <div class="form-group">
                <div class="color-666 text-right mb-5">
                  {{Getter_User_Info.registerType == 1 ? Getter_User_Info.mobile : Getter_User_Info.email}}
                </div>
                <div class="verify-wrap">
                  <div
                    class="quasar-qfield glay-bg secret-key-input"
                    :error="form.validateCode.$error"
                    :error-label="getErrorLabel(form.validateCode, 'validateCode')">
                    <v-text-field
                      v-model="form.validateCode"
                      @blur="form.validateCode.$touch"
                      :class="{'invalid-class': form.validateCode.$error}"
                      :float-label="Getter_User_Info.registerType == 1 ? '手机验证码' : '邮箱验证码'" />
                  </div>

                  <VerifyBtn class="verify-btn"
                             :type="Getter_User_Info.registerType == 1 ? 'phone' : 'email'"
                             :value="Getter_User_Info.registerType == 1 ? Getter_User_Info.mobile : Getter_User_Info.email"
                             :country-code="Getter_User_Info.registerType == 1 ? Getter_User_Info.countryCode : ''"></VerifyBtn>
                </div>
              </div>-->
              <div class="form-group">
                <!-- <div
                  class="quasar-qfield glay-bg secret-key-input"
                  :error="form.code.$error"
                  :error-label="getErrorLabel(form.code, 'gaCode')"
                >
                  <v-text-field
                    type="password"
                    v-model="form.code"
                    @blur="form.code.$touch"
                    maxlength="6"
                    :class="{ 'invalid-class': form.code.$error }"
                    :float-label="$t('labels.gaCode')"
                  />
                </div>-->
                <ValidationObserver ref="observer">
                  <ValidationProvider name="labels.gaCode" :rules="rules.gaCode" v-slot="{ errors }">
                    <v-text-field
                      ref="gaCode"
                      v-model="form.code"
                      outlined
                      :label="$t('labels.gaCode')"
                      :error-messages="errors[0]"
                      :type="showGaCode ? 'text' : 'password'"
                      :append-icon="showGaCode ? 'visibility' : 'visibility_off'"
                      @click:append="showGaCode = !showGaCode"
                    ></v-text-field>
                  </ValidationProvider>
                </ValidationObserver>
              </div>

              <div>
                <!-- <q-btn
                  class="no-shadow step-btn"
                  @click="confirmBtnClick"
                  :class="{ disabled: committing }"
                  :label="$t('labels.acc.ga.setup')"
                />-->
                <v-btn
                  class="step-btn ma-0"
                  depressed
                  @click="confirmBtnClick"
                >{{$t('labels.acc.ga.setup')}}</v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--查看谷歌验证码 start-->
      <!-- <div class="google-verification-check" v-if="Getter_User_Info.gaStatus === 1">
        <div class="form-card-body content">
          <div class="content-left">
            <span class="content-left-title">谷歌验证码</span>
            <span class="content-left-txt">资产提现、修改密码及安全设置时需要输入谷歌验证码。</span>
          </div>
          <q-btn
            :class="[ enableGaCheck === 1 ? 'close-btn' : 'open-btn','no-shadow','btn']"
            :label="enableGaCheck === 1 ? '关闭' : '开启' "
            @click="showModal"/>
        </div>
      </div>-->
      <!--查看谷歌验证码 end-->
    </div>
  </div>
</template>

<script>
import index from './google-verification-bind.js';
export default index;
</script>

<style src="@/common/styles/mixin/account-bind.scoped.styl" lang="stylus" scoped></style>
<style lang="stylus" scoped>
@import './google-verification-bind.scoped.styl';
</style>

<style scoped>
.readonly >>> .v-input__slot {
  background-color: #f4f4f4;
}
</style>